module.exports = __webpack_public_path__ + "img/18_d.b903e041.jpg";